<mat-card class="mat-coord">

  <div *ngIf="isPlayback" class="playback-player">
    <button mat-icon-button matTooltip="-30s" style="color:#FF7F50;"(click)= "handleJumpBackward()">
        <mat-icon>replay_30</mat-icon>
    </button>

    <button mat-icon-button matTooltip="+30s" style="color: #FF7F50;" (click)="handleJumpForward()">
        <mat-icon>forward_30</mat-icon>
    </button>

    <button mat-icon-button matTooltip="Stop Playback" style="color:#FF7F50;" (click)= "handleStopPlayback()">
      <mat-icon>stop</mat-icon>
    </button>
  
    <button mat-icon-button matTooltip="Playback speed" style="color: #FF7F50;" (click)="handleSpeedForward()">
        <mat-icon>fast_forward</mat-icon>
    </button>
    <div *ngIf = "showMultiplier" class="playback-speed">
      {{ currentSpeedMultiplier }}
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center" style="flex: 1 1 auto;">
    <!-- <mat-icon class="location-icon">place</mat-icon> -->
    <div fxLayoutAlign="center" class="monospace-font" style="-webkit-user-select: none" (click)="onCoordClick()">
      {{mapCoordinates}}
      <!-- {{mapCoordinates}}<br>{{mapHeight}} -->
    </div>
  </div>
</mat-card>

<!-- <mat-card *ngIf="playbackModePanel" class="mat-playback">
    <div fxLayout="row" style="flex: 1 1 auto">
      <img (click)="stopPlaybackMode()" [matTooltip]="'Stop Playback Mode'" src="../../assets/Images/stop-playback-icon.svg" alt="stop-icon" class="stop-icon">
      <img [matTooltip]="'Playback Mode'" src="../../assets/Images/red-blink-icon.svg" alt="red-blink-icon" class="red-blink-icon">
    </div>
</mat-card>  -->
